import { useTranslation } from "contexts/i18nContext";

interface FileActionsProps {
  fileUrl: string;
}

const FileActions = ({ fileUrl }: FileActionsProps) => {
  const { t } = useTranslation();
  const isMedia = fileUrl.startsWith("/media/");
  const finalUrl = isMedia
    ? `${process.env.REACT_APP_API_BASE_URL}/${fileUrl}`
    : fileUrl;
  // const finalUrl = fileUrl;

  return (
    <div className="flex items-center gap-2 text-sm">
      <a
        href={finalUrl}
        // target="_blank"
        download
        className="text-xs text-gray-500 hover:underline"
      >
        {t("downloadFile")}
      </a>
      <a
        href={finalUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="text-xs bg-gray-300 px-5 py-1 rounded-xl hover:bg-gray-800 hover:text-white"
      >
        {t("view")}
      </a>
    </div>
  );
};

export default FileActions;
